
const docPageBase = {
  margin: "auto",
  padding: 15, 
  maxWidth: 1000 }

const docListBase = Object.assign({}, 
  docPageBase,
  {
    maxWidth: 1300
  })

export const docPageStyle = (overwrite) => Object.assign({}, docPageBase, overwrite)
  
export const docListStyle = (overwrite) => Object.assign({}, docListBase, overwrite)
